import * as daccaActions from './actions';

import { DaccaActionTypes, DaccaState } from './types';

import { ActionType } from 'typesafe-actions';
import { Reducer } from 'redux';
import { getEnv } from '../../utils/env/env.manager';

export type DaccaAction = ActionType<typeof daccaActions>;

const env = getEnv();
const daccaBaseURL = env.daccaBaseURL;

const initialState: DaccaState = {
    daccaCalculations: [],
    loading: false,
    daccaBaseURL: daccaBaseURL
};

const reducer: Reducer<DaccaState, DaccaAction> = (state = initialState, action): DaccaState => {
  switch (action.type) {
    case DaccaActionTypes.FETCH_DACCA_CALCULATIONS_SUCCESS: {
      return { ...state, daccaCalculations: action.payload };
    }
    case DaccaActionTypes.FETCH_DACCA_CALCULATIONS_FAIL: {
      return state;
    }
    case DaccaActionTypes.IMPORT_LINES_FROM_DACCA_FAIL: {
      return state;
    }
    case DaccaActionTypes.FETCH_DACCA_TOKEN_FAIL: {
      return state;
    }
    case DaccaActionTypes.IMPORT_LINES_FROM_DACCA: {
      return {...state, loading: true };
    }
    case DaccaActionTypes.IMPORT_LINES_FROM_DACCA_SUCCESS: {
      return {...state, loading: false };
    }
    default: {
      return state;
    }
  }
};

export { reducer as daccaReducer, initialState as daccaInitialState };
